'use strict';

import Api from "./Api";

export default class Cashflow extends Api {

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = [], flow = undefined) {
        const url = this.url + 'cashflow/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
                flow: flow,
            },
        });
    }

    static get(id) {
        const url = this.url + 'cashflow/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'cashflow/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'cashflow/update';

        return this.getAxios().post(url, data);
    }

    static addSale(data) {
        const url = this.url + 'cashflow/add-sale';

        return this.getAxios().post(url, data);
    }

    static addSurcharge(data) {
        const url = this.url + 'cashflow/add-surcharge';

        return this.getAxios().post(url, data);
    }

    static remove(id) {
        const url = this.url + 'cashflow/remove';

        return this.getAxios().post(url, {id: id});
    }

    static updateSum(id, newSum) {
        const url = this.url + 'cashflow/update-sum';

        return this.getAxios().post(url, {
            id: id,
            sum: newSum,
        });
    }

}
